<template>
  <main class="block-main main" :class="device_platform">
    <video
      class="main__video"
      src="../video/fitnessmania-intro.mp4"
      loop
      muted
      autoplay
      playsinline
    ></video>
    <div class="main__content">
      <div class="container">
        <h2 class="main__title title">Приглашаем на бесплатный открытый урок!</h2>
        <p class="main__subtitle">Ждем всех желающих 12 июля</p>
        <button
          class="main__btn button button_theme_primary"
          @click="
            getCall({
              type: 'sale',
              form: 'main',
              title: 'Получить предложение',
            })
          "
        >
          <span>Записаться на урок</span>
        </button>
      </div>
    </div>
  </main>
</template>

<script>
import Mixin from "../common/mixin";
import finance from "../common/finance";

export default {
  name: "block-main",
  mixins: [Mixin, finance],
  data() {
    return {};
  },
  methods: {
    getAgreement() {
      this.$emit("getAgreement");
    },
  },
};
</script>

<style scoped lang="scss">
@import "../styles/constants.scss";

.try-fix {
  margin: 0;
}

.main {
  display: flex;
  align-items: center;
  /* background-image: url("../images/bg/bg-main.webp");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center bottom; */
  height: calc(100vw * 9 / 16);
  color: #fff;
  position: relative;
  z-index: 10;
  margin-bottom: 40px;
  overflow: hidden;
  clip-path: polygon(0 0, 100% 0%, 100% 79%, 0% 100%);

  &__content {
    position: relative;
    width: 100%;
    height: 100%;
    background-color: rgba(#000, 0.55);
    padding-bottom: 40px;

    .container {
      padding-top: 10%;
    }
  }

  &__video {
    position: absolute;
    width: 100%;
    height: 100%;
  }

  &__title {
    margin: 0 0 7px;
    line-height: calcFontSize(53, 83, 320, 1440);
    color: #fff;
  }

  &__subtitle {
    font-size: calcFontSize(14, 26, 320, 1440);
    margin-bottom: 40px;
  }

  &__title,
  &__subtitle {
    text-align: center;
  }

  &__btn {
    max-width: 309px;
    margin: 0 auto;
  }
}

@media (max-width: 800px) {
  .main {
    height: 540px;
    margin-bottom: 0;
    clip-path: polygon(0 0, 100% 0%, 100% 86%, 0% 100%);

    &__video {
      width: auto;
    }
  }
}

@media (max-width: 550px) {
  .main {
    height: 395px;

    &__content {
      padding-bottom: 100px;
      height: 100%;
    }

    .container {
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
    }

    &__subtitle {
      margin-bottom: 19px;
    }

    &__btn {
      max-width: 220px;
      height: 42px;
      font-size: 16px;
    }
  }
}
</style>
